import { render } from "./BlogVapeShopCustomWebsite.vue?vue&type=template&id=771e564c"
import script from "./BlogVapeShopCustomWebsite.vue?vue&type=script&lang=js"
export * from "./BlogVapeShopCustomWebsite.vue?vue&type=script&lang=js"

import "./BlogVapeShopCustomWebsite.vue?vue&type=style&index=0&id=771e564c&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__